import { Container, Title, Text, Grid, GridCol, Image } from '@mantine/core';
import classes from './SplashFeatureSection.module.css';

interface SplashFeatureSectionProps {
  imageSrc: string;
  imageAlt: string;
  title: string;
  description: React.ReactNode;
}

export function SplashFeatureSection({ imageSrc, imageAlt, title, description }: SplashFeatureSectionProps) {
  return (
    <Container className={classes.wrapper} size="lg">
      <Grid gutter="xl" align="center">
        <GridCol span={{ base: 12, md: 6 }}>
          <div className={classes.imageContainer}>
            <Image
              src={imageSrc}
              alt={imageAlt}
              radius="lg"
              className={classes.featureImage}
            />
          </div>
        </GridCol>

        <GridCol span={{ base: 12, md: 6 }}>
          <div className={classes.textContent}>
            <Title className={classes.japaneseTitle}>{title}</Title>
            <Text size="lg" c="dimmed" mt="md" className={classes.japaneseDescription}>
              {description}
            </Text>
          </div>
        </GridCol>
      </Grid>
    </Container>
  );
}
